var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"middle-bar"},[_c('div',{staticClass:"titleName mb-9"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"#5F7692"}},[_vm._v("mdi-bag-checked")]),_c('span',[_vm._v("Trading & Account History")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }